import { render, staticRenderFns } from "./QuizTaking.vue?vue&type=template&id=9c8cc218&scoped=true"
import script from "./QuizTaking.vue?vue&type=script&lang=js"
export * from "./QuizTaking.vue?vue&type=script&lang=js"
import style0 from "./QuizTaking.vue?vue&type=style&index=0&id=9c8cc218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8cc218",
  null
  
)

export default component.exports